import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SuccessScoringGroupService from "../../../Domain/SuccessScoringGroup/SuccessScoringGroup.service";
const getIndicatorClass = (group) => {
    const lowRiskClass = "text-success fa-check-circle";
    const mediumRiskClass = "text-warning fa-minus-circle";
    const highRiskClass = "text-danger fa-exclamation-circle";
    const unknownClass = "text-muted fa-question-circle";
    if (!group) {
        return unknownClass;
    }
    switch (parseInt(group.id, 10)) {
        case SuccessScoringGroupService.HighId:
            return highRiskClass;
        case SuccessScoringGroupService.MediumId:
            return mediumRiskClass;
        case SuccessScoringGroupService.LowId:
            return lowRiskClass;
        default:
            return unknownClass;
    }
};
/**
 * Displays the term success score and course success score
 *
 * @param {*} props - The properties necessary for this component to function.
 */
const SuccessIndicators = (props) => props.termSuccessScore || props.courseSuccessScore ? (_jsxs("div", { className: "d-flex justify-content-around pt-1", children: [props.termSuccessScore && (_jsx("span", { className: `fa ${getIndicatorClass(props.termSuccessScore)}`, title: `Term Persistence: ${props.termSuccessScore
                ? props.termSuccessScore.name
                : "No Persistence Risk Score for this student. Contact your Aviso administrator for more details."}` })), props.courseSuccessScore && (_jsx("span", { className: `fa ${getIndicatorClass(props.courseSuccessScore)}`, title: `Course Completion: ${props.courseSuccessScore
                ? props.courseSuccessScore.name
                : "No Course Completion Risk Score for this student. Contact your Aviso administrator for more details."}` }))] })) : null;
export default SuccessIndicators;
